import FormData from "../../../dto/Form/FormData";
import FormSaveData from "../../../dto/Form/FormSaveData";

export default class FormState {
    public formData: FormData | null = null;

    public saveData: FormSaveData = new FormSaveData();

    public captchaImageUrl: string = "";

    public captchaValue: string = "";

    public currentFormStep: number = 0;

    public isLoading: boolean = false;

    public errorOccured: boolean = false;

    public shouldValidate: boolean = false;

    public saveError: boolean = false;

    public formWasSent: boolean = false;
}